interface AddScript {
  crossOrigin?: 'anonymous' | 'use-credentials' | '' | false;
  onload?: (event: Event) => void;
  src: string;
}

export function addScript({ src, onload, crossOrigin = 'anonymous' }: AddScript): () => void {
  const prevScript = Array.from(document.getElementsByTagName('script')).find(
    (script: HTMLScriptElement) => script.getAttribute('src') === src
  );

  if (prevScript) {
    const oldOnload = prevScript.onload;
    prevScript.onload = (event: Event) => {
      oldOnload && oldOnload.call(prevScript, event);
      onload && onload(event);
    };
    return () => {
      document.body.removeChild(prevScript);
    };
  }

  const script = document.createElement('script');
  if (onload) {
    script.onload = onload;
  }
  script.async = true;
  if (crossOrigin !== false) {
    script.crossOrigin = crossOrigin;
  }
  script.src = src;
  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  };
}
